/**
 * 包括契約登録API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 包括契約情報
 */
export interface Sgkb709aResInclusiveCtrInfoDto {
    /**
     * 包括お客さま番号
     */
    inclusioncontractVisitornumber?: string;

    /**
     * 包括契約履歴番号
     */
    inclusioncontractRrkno?: string;

    /**
     * 包括契約年度内通番号
     */
    inclusioncontractYearnaiSrno?: string;
}
